import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { DOCUMENT } from '@angular/common';
class GdsYoutubeService {
  constructor(document) {
    this.document = document;
  }
  /**
   * Gets upr gds youtube player service
   * @param videoId
   * @param videoCaption
   * @param contrast
   * @returns get
   */
  get(videoId, videoCaption, contrast) {
    const youTubePlayer = this.document.createElement('gds-youtube-player');
    youTubePlayer.setAttribute('video', videoId);
    youTubePlayer.setAttribute('caption', videoCaption);
    youTubePlayer.setAttribute('contrast', contrast);
    youTubePlayer.setAttribute('autoplay', true);
    return youTubePlayer;
  }
  static {
    this.ɵfac = function GdsYoutubeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsYoutubeService)(i0.ɵɵinject(DOCUMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsYoutubeService,
      factory: GdsYoutubeService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsYoutubeService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], null);
})();
class GdsYoutubeModule {
  static {
    this.ɵfac = function GdsYoutubeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsYoutubeModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsYoutubeModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [GdsYoutubeService]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsYoutubeModule, [{
    type: NgModule,
    args: [{
      providers: [GdsYoutubeService]
    }]
  }], null, null);
})();

/*
 * Public API Surface of gds-youtube
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsYoutubeModule, GdsYoutubeService };
